/* Highside Lab entry ledger client. Talks to the Apps Script web app.
   Anonymous fetch first, script-tag (JSONP) as a fallback.
   Features: live entry counter, My Entries for logged-in customers, email + order lookup for guests. */
(function () {
  var cfg = window.HSL_LEDGER;
  if (!cfg || !cfg.url) return;
  var seq = 0;

  function jsonp(params, ok, fail) {
    var name = '__hslLedger' + (++seq) + '_' + Date.now();
    var s = document.createElement('script');
    var done = false;
    var timer = setTimeout(function () { finish(); fail && fail('timeout'); }, 15000);
    function finish() {
      if (done) return; done = true; clearTimeout(timer);
      try { delete window[name]; } catch (e) { window[name] = undefined; }
      if (s.parentNode) s.parentNode.removeChild(s);
    }
    window[name] = function (data) { if (done) return; finish(); ok(data); };
    var q = [];
    Object.keys(params).forEach(function (k) { q.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k])); });
    q.push('callback=' + name);
    s.src = cfg.url + (cfg.url.indexOf('?') > -1 ? '&' : '?') + q.join('&');
    s.onerror = function () { if (done) return; finish(); fail && fail('network'); };
    document.head.appendChild(s);
  }

  // Anonymous fetch first (no Google cookies, so signed-in Google accounts cannot interfere),
  // then the script-tag (JSONP) method as a fallback.
  function request(params, ok, fail) {
    var qs = Object.keys(params).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');
    var url = cfg.url + (cfg.url.indexOf('?') > -1 ? '&' : '?') + qs;
    if (!window.fetch) { jsonp(params, ok, fail); return; }
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
    fetch(url, { credentials: 'omit', redirect: 'follow', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.text(); })
      .then(function (t) { clearTimeout(timer); ok(JSON.parse(t)); })
      .catch(function () { clearTimeout(timer); jsonp(params, ok, fail); });
  }

  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined) e.textContent = text;
    return e;
  }

  function renderSummary(box, d) {
    box.textContent = '';
    if (!d || !d.ok) {
      var msg = el('p', 'ms-note', (d && d.error) || 'We could not load your entries. Please try again in a minute.');
      msg.setAttribute('role', 'alert');
      box.appendChild(msg);
      return;
    }
    box.appendChild(el('p', 'ms-entries__count', fmt(d.entries)));
    box.appendChild(el('p', 'ms-entries__label', d.entries === 1 ? 'Entry' : 'Entries'));
    var split = [];
    if (d.online) split.push(fmt(d.online) + ' from orders');
    if (d.mailin) split.push(fmt(d.mailin) + ' from mail-in entries');
    if (split.length) box.appendChild(el('p', 'ms-entries__split', split.join('  |  ')));
    if (d.orders && d.orders.length) {
      var ul = el('ul', 'ms-entries__orders');
      d.orders.forEach(function (o) {
        var li = el('li', o.entries > 0 ? '' : 'is-void');
        li.appendChild(el('span', '', o.order));
        li.appendChild(el('span', '', o.date));
        li.appendChild(el('span', '', o.status));
        li.appendChild(el('span', '', o.entries > 0 ? '+' + fmt(o.entries) : '0'));
        ul.appendChild(li);
      });
      box.appendChild(ul);
    } else {
      box.appendChild(el('p', 'ms-note', d.mailOnly ? 'Showing mail-in entries only. Look up with your order number to see online orders too.' : 'No orders yet. Every $5 spent earns an entry, and Victory, Elite and Ultimate packs earn bonus entries.'));
    }
    box.appendChild(el('p', 'ms-note', 'Entries update every few minutes after an order is paid.'));
  }

  function initStats() {
    var targets = document.querySelectorAll('[data-hsl-stat]');
    var wantsPool = document.querySelector('[data-hsl-pool]');
    if (!targets.length && !wantsPool) return;
    request({ action: 'stats' }, function (d) {
      if (!d || !d.ok) return;
      Array.prototype.forEach.call(targets, function (t) {
        t.textContent = fmt(d.entries);
        var wrap = t.closest('[data-hsl-stat-wrap]');
        if (wrap) wrap.hidden = false;
      });
      document.dispatchEvent(new CustomEvent('hsl:stats', { detail: { entries: d.entries, entrants: d.entrants } }));
    });
  }

  function initMe() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hsl-me]'), function (box) {
      var email = box.getAttribute('data-email'), token = box.getAttribute('data-token');
      if (!email || !token) return;
      request({ action: 'me', email: email, t: token }, function (d) { renderSummary(box, d); },
        function () { renderSummary(box, { ok: false }); });
    });
  }

  function initGuest() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hsl-guest]'), function (form) {
      var out = form.parentNode.querySelector('[data-hsl-result]');
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var email = form.elements['email'].value.trim();
        var order = form.elements['order'].value.trim();
        var zipEl = form.elements['zip']; var zip = zipEl ? zipEl.value.trim() : ''; if (!email || (!order && !zip)) { out.textContent = 'Enter your email plus an order number or the ZIP/postal code from your mail-in card.'; return; }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        out.textContent = 'Checking...';
        request({ action: 'guest', email: email, order: order, zip: order ? '' : zip }, function (d) {
          if (btn) btn.disabled = false;
          renderSummary(out, d);
        }, function () {
          if (btn) btn.disabled = false;
          renderSummary(out, { ok: false });
        });
      });
    });
  }

  function start() { initStats(); initMe(); initGuest(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();